export default __webpack_public_path__ + "static/media/onepay_payku.22dbe1d7.webp";